import { START_DATE } from "react-dates/constants";
import classes from "./styles.module.scss";

export default (focusedInput) => {
  if (!document) return;
  const dayPicker = document.querySelector(".DayPicker");
  if (!dayPicker) return;
  Array.from(document.getElementsByClassName(classes.DateInputTitle)).forEach(
    (el) => el.remove()
  );
  const title = document.createElement("div");
  title.className = classes.DateInputTitle;
  title.innerHTML = `When does your event <b>${
    focusedInput === START_DATE ? "start" : "finish"
  }</b>?`;
  dayPicker.insertBefore(title, dayPicker.childNodes[0]);
};
